/**
 * FlightDeck meetings HTTP paths.
 * Portal routes require `Version: 2025-11-14`.
 */
export const meetingsApiPaths = {
  list: '/meetings',
  detail: (id: string) => `/meetings/${id}`,
  update: (id: string) => `/meetings/${id}`,
  speakers: (id: string) => `/meetings/${id}/speakers`,
  actionItem: (meetingId: string, actionItemId: string) =>
    `/meetings/${meetingId}/action-items/${actionItemId}`,
  companies: (id: string) => `/meetings/${id}/companies`,
  company: (id: string, companyId: number | string) =>
    `/meetings/${id}/companies/${companyId}`
} as const;

export const MEETINGS_API_VERSION = '2025-11-14';
